import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/addRow/translation.createFeature.mutation.gql"
import type {
  TranslationCreateFeatureMutation,
  TranslationCreateFeatureMutationVariables,
} from "@/v2-backoffice-client/translation/addRow/__types__/translation.createFeature.mutation"

type Options = MutationHookOptions<
  TranslationCreateFeatureMutation,
  TranslationCreateFeatureMutationVariables
>

export function useTranslationCreateFeatureMutation(options?: Options) {
  return useMutation<
    TranslationCreateFeatureMutation,
    TranslationCreateFeatureMutationVariables
  >(mutation, options)
}
